<div class="row_1">
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
        <button mat-raised-button class="black-btn" (click)="reportAsnSheet();">RUN REPORT ASN</button>
        <hr class="hidden_hr_tag">
        <div class="grid-agg">
            <br>
            <div class="col-6" style="padding:0 0 0 1.2%">
                <div class="upload_file">
                    <div style="padding-left: 2%;">
                        <label class="label uploadFileHeading"> Upload Export ASN</label>
                    </div>
                    <div id="dropareaZoneBorder" class="dropareaZoneASNExport">
                        <!-- <input id="fileInputASN" type="file" accept=".xls, .xlsx, .csv"
                            (change)="fileChange('ASNExport',$event)" style="display:none" /> -->
                        <input id="fileInputASN" type="file" accept=".xls, .xlsx, .csv" #fileInputASN
                            (change)="onFileSelected('ASNExport',$event)" style="display:none" />
                        <mat-icon id="cloudUpload" class="mat-icon material-icons upload-icon" aria-hidden="true">
                            cloud_upload
                        </mat-icon>
                        <p *ngIf="!asnExportShortFileName" class="dragText">Drag and Drop to Upload file (or) </p>
                        <p *ngIf="asnExportShortFileName" class="dragText">{{asnExportShortFileName}}</p>
                        <button style="margin-top: 1.5%;" class="black-btn" (click)="newuploadASNExport();">
                            UPLOAD
                            <img src="./assets/images/file_upload.svg" style="margin-left: 2px;">
                        </button>
                        <img src="./assets/images/vertical_line.svg" style="float: right; margin-top: 1.8%;"
                            class="line">
                        <button style="margin-top: 1.5%;" class="black-btn"
                            onclick="document.getElementById('fileInputASN').click();">BROWSE</button>

                    </div>
                    <button mat-raised-button class="black-btn" style="margin-top: 1.5%; float:left" (click)="asnExportShortFileName = null;">CLEAR</button>
                    <!-- <img src="./assets/images/vertical_line.svg" style="float: right;margin-top: 1.2%;" class="line"> -->
                </div>
            </div>
            <br><br>
            <div class="col-6" style="padding:2.8% 0 0 1.2%">
                <div class="upload_file">
                    <div style="padding-left: 2%;">
                        <label class="label uploadFileHeading">SAP Verification</label>
                    </div>
                    <div id="dropareaZoneBorder" class="dropareaZoneSAPVerification">
                        <!-- <input id="fileInputSAPVerification" type="file" accept=".xls, .xlsx, .csv"
                            (change)="fileChange('SAPVerification',$event)" style="display:none" /> -->
                        <input id="fileInputSAPVerification" type="file" accept=".xls, .xlsx, .csv" #fileInputSAP
                            (change)="onFileSelected('SAPVerification',$event)" style="display:none" />
                        <mat-icon id="cloudUpload" class="mat-icon material-icons upload-icon" aria-hidden="true">
                            cloud_upload
                        </mat-icon>
                        <p *ngIf="!sapVerificationShortFileName" class="dragText">Drag and Drop to Upload file (or) </p>
                        <p *ngIf="sapVerificationShortFileName" class="dragText">{{sapVerificationShortFileName}}</p>
                        <button style="margin-top: 1.5%;" class="black-btn" (click)="newuploadSAPVerification();">
                            UPLOAD
                            <img src="./assets/images/file_upload.svg" style="margin-left: 2px;">
                        </button>
                        <img src="./assets/images/vertical_line.svg" style="float: right; margin-top: 1.8%;"
                            class="line">
                        <button style="margin-top: 1.5%;" class="black-btn"
                            onclick="document.getElementById('fileInputSAPVerification').click();">BROWSE</button>

                    </div>
                    <button mat-raised-button class="black-btn" style="margin-top: 1.5%; float:left" (click)="sapVerificationShortFileName = null;">CLEAR</button>
                    <!-- <img src="./assets/images/vertical_line.svg" style="float: right;margin-top: 1.2%;" class="line"> -->
                </div>
            </div>
            <br><br>
            <div class="col-6" style="padding:2.8% 0 0 1.2%">
                <div class="upload_file">
                    <div style="padding-left: 2%;">
                        <label class="label uploadFileHeading">Run Import SAP</label>
                    </div>
                    <div id="dropareaZoneBorder" class="dropareaZoneSAPImport">
                        <!-- <input id="fileInputSAPImport" type="file" accept=".xls, .xlsx, .csv"
                            (change)="fileChange('SAPImport',$event)" style="display:none" /> -->
                        <input id="fileInputSAPImport" type="file" accept=".xls, .xlsx, .csv" #fileInputSAPImp
                            (change)="onFileSelected('SAPImport',$event)" style="display:none" />
                        <mat-icon id="cloudUpload" class="mat-icon material-icons upload-icon" aria-hidden="true">
                            cloud_upload
                        </mat-icon>
                        <p *ngIf="!sapImportShortFileName" class="dragText">Drag and Drop to Upload file (or) </p>
                        <p *ngIf="sapImportShortFileName" class="dragText">{{sapImportShortFileName}}</p>
                        <button style="margin-top: 1.5%;" class="black-btn" (click)="newuploadSAPImport();">
                            UPLOAD
                            <img src="./assets/images/file_upload.svg" style="margin-left: 2px;">
                        </button>
                        <img src="./assets/images/vertical_line.svg" style="float: right; margin-top: 1.8%;"
                            class="line">
                        <button style="margin-top: 1.5%;" class="black-btn"
                            onclick="document.getElementById('fileInputSAPImport').click();">BROWSE</button>

                    </div>
                    <button mat-raised-button class="black-btn" style="margin-top: 1.5%; float:left" (click)="sapImportShortFileName = null;">CLEAR</button>
                    <!-- <img src="./assets/images/vertical_line.svg" style="float: right;margin-top: 1.2%;" class="line"> -->
                </div>
            </div>
            <br>
            <br>
            <br>
            <hr>

        </div>
    </div>
</div>